// ══════════════════════════════════════════════════════════════════════════════
// CATÉGORIES BTP UNIFIÉES - Pour Marketplace ET Petites Annonces
// Identiques entre les deux univers pour une expérience cohérente
// ══════════════════════════════════════════════════════════════════════════════

import { 
  Zap, Droplets, TreeDeciduous, Paintbrush, HardHat, Hammer, 
  Layers, Ruler, Flame, Building2, ShieldCheck, Wind, Wrench, Package
} from 'lucide-react';

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// CATÉGORIES PRINCIPALES (16 rayons)
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const CATEGORIES_BTP = [
  {
    id: 'electricite',
    slug: 'rayon-electricite',
    label: 'Électricité',
    icon: Zap,
    emoji: '⚡',
    color: '#1E3A5F',
    subcategories: [
      { id: 'tableaux', label: 'Tableaux électriques' },
      { id: 'appareillage', label: 'Appareillage (prises, interrupteurs)' },
      { id: 'cables', label: 'Câbles & fils' },
      { id: 'eclairage', label: 'Éclairage' },
      { id: 'domotique', label: 'Domotique' },
      { id: 'protection', label: 'Disjoncteurs & protection' },
    ]
  },
  {
    id: 'plomberie',
    slug: 'rayon-plomberie',
    label: 'Plomberie / Sanitaire',
    icon: Droplets,
    emoji: '🚿',
    color: '#1E3A5F',
    subcategories: [
      { id: 'robinetterie', label: 'Robinetterie' },
      { id: 'evacuation', label: 'Évacuation & PVC' },
      { id: 'alimentation', label: 'Alimentation eau' },
      { id: 'wc', label: 'WC & accessoires' },
      { id: 'chauffe-eau', label: 'Chauffe-eau' },
      { id: 'raccords', label: 'Raccords & fixations' },
    ]
  },
  {
    id: 'jardin',
    slug: 'rayon-jardin-paysage',
    label: 'Jardin & Paysage',
    icon: TreeDeciduous,
    emoji: '🌳',
    color: '#1E3A5F',
    subcategories: [
      { id: 'tondeuses', label: 'Tondeuses & robots' },
      { id: 'arrosage', label: 'Arrosage' },
      { id: 'clotures', label: 'Clôtures & portails' },
      { id: 'terrassement', label: 'Terrassement' },
      { id: 'amenagement', label: 'Aménagement extérieur' },
      { id: 'mobilier', label: 'Mobilier de jardin' },
    ]
  },
  {
    id: 'piscine',
    slug: 'rayon-piscine-spa',
    label: 'Piscine & Spa',
    icon: Droplets,
    emoji: '🏊',
    color: '#1E3A5F',
    subcategories: [
      { id: 'filtration', label: 'Filtration & pompes' },
      { id: 'traitement', label: 'Traitement eau' },
      { id: 'accessoires-piscine', label: 'Accessoires piscine' },
      { id: 'liner', label: 'Liners & bâches' },
      { id: 'spa', label: 'Spas & jacuzzis' },
      { id: 'robot-piscine', label: 'Robots de piscine' },
    ]
  },
  {
    id: 'peinture',
    slug: 'rayon-peinture-decoration',
    label: 'Peinture & Décoration',
    icon: Paintbrush,
    emoji: '🎨',
    color: '#F97316',
    subcategories: [
      { id: 'peinture-interieur', label: 'Peinture intérieure' },
      { id: 'peinture-exterieur', label: 'Peinture extérieure' },
      { id: 'papier-peint', label: 'Papier peint' },
      { id: 'outils-peinture', label: 'Outils de peinture' },
      { id: 'preparation', label: 'Préparation des supports' },
      { id: 'lasures', label: 'Lasures & vernis' },
    ]
  },
  {
    id: 'maconnerie',
    slug: 'rayon-maconnerie-gros-oeuvre',
    label: 'Maçonnerie & Gros Œuvre',
    icon: HardHat,
    emoji: '🧱',
    color: '#F97316',
    subcategories: [
      { id: 'parpaings', label: 'Parpaings & briques' },
      { id: 'ciment', label: 'Ciment & béton' },
      { id: 'mortier', label: 'Mortier & enduits' },
      { id: 'ferraillage', label: 'Ferraillage' },
      { id: 'coffrage', label: 'Coffrage' },
      { id: 'agregats', label: 'Sable, graviers, agrégats' },
    ]
  },
  {
    id: 'renovation',
    slug: 'rayon-renovation-interieure',
    label: 'Rénovation Intérieure',
    icon: Hammer,
    emoji: '🔨',
    color: '#1E3A5F',
    subcategories: [
      { id: 'placo', label: 'Plaques de plâtre' },
      { id: 'cloisons', label: 'Cloisons & ossatures' },
      { id: 'faux-plafonds', label: 'Faux plafonds' },
      { id: 'enduits-interieurs', label: 'Enduits intérieurs' },
      { id: 'accessoires-placo', label: 'Accessoires placo' },
    ]
  },
  {
    id: 'carrelage',
    slug: 'rayon-carrelage-revetement',
    label: 'Carrelage & Revêtements',
    icon: Layers,
    emoji: '🔲',
    color: '#1E3A5F',
    subcategories: [
      { id: 'carrelage-sol', label: 'Carrelage sol' },
      { id: 'carrelage-mur', label: 'Carrelage mural' },
      { id: 'mosaique', label: 'Mosaïque' },
      { id: 'parquet', label: 'Parquet & stratifié' },
      { id: 'colle-joints', label: 'Colles & joints' },
      { id: 'outils-carrelage', label: 'Outils de carrelage' },
    ]
  },
  {
    id: 'menuiserie',
    slug: 'rayon-menuiserie',
    label: 'Menuiserie & Fermetures',
    icon: Ruler,
    emoji: '🚪',
    color: '#F97316',
    subcategories: [
      { id: 'portes', label: 'Portes intérieures' },
      { id: 'fenetres', label: 'Fenêtres' },
      { id: 'volets', label: 'Volets & stores' },
      { id: 'portes-garage', label: 'Portes de garage' },
      { id: 'escaliers', label: 'Escaliers' },
      { id: 'quincaillerie', label: 'Quincaillerie' },
    ]
  },
  {
    id: 'chauffage',
    slug: 'rayon-chauffage',
    label: 'Chauffage & Énergie',
    icon: Flame,
    emoji: '🔥',
    color: '#F97316',
    subcategories: [
      { id: 'radiateurs', label: 'Radiateurs' },
      { id: 'chaudieres', label: 'Chaudières' },
      { id: 'pompes-chaleur', label: 'Pompes à chaleur' },
      { id: 'poeles', label: 'Poêles & inserts' },
      { id: 'plancher-chauffant', label: 'Plancher chauffant' },
      { id: 'regulation', label: 'Régulation & thermostats' },
    ]
  },
  {
    id: 'couverture',
    slug: 'rayon-couverture-toiture',
    label: 'Couverture & Toiture',
    icon: Building2,
    emoji: '🏠',
    color: '#1E3A5F',
    subcategories: [
      { id: 'tuiles', label: 'Tuiles' },
      { id: 'ardoises', label: 'Ardoises' },
      { id: 'gouttières', label: 'Gouttières & descentes' },
      { id: 'etancheite', label: 'Étanchéité toiture' },
      { id: 'velux', label: 'Fenêtres de toit' },
      { id: 'accessoires-toiture', label: 'Accessoires de toiture' },
    ]
  },
  {
    id: 'isolation',
    slug: 'rayon-isolation',
    label: 'Isolation',
    icon: ShieldCheck,
    emoji: '🧊',
    color: '#1E3A5F',
    subcategories: [
      { id: 'laine-verre', label: 'Laine de verre' },
      { id: 'laine-roche', label: 'Laine de roche' },
      { id: 'polystyrene', label: 'Polystyrène' },
      { id: 'isolants-naturels', label: 'Isolants naturels' },
      { id: 'isolation-mince', label: 'Isolation mince' },
      { id: 'accessoires-isolation', label: 'Accessoires d\'isolation' },
    ]
  },
  {
    id: 'climatisation',
    slug: 'rayon-climatisation-ventilation',
    label: 'Climatisation & Ventilation',
    icon: Wind,
    emoji: '❄️',
    color: '#1E3A5F',
    subcategories: [
      { id: 'climatiseurs', label: 'Climatiseurs' },
      { id: 'vmc', label: 'VMC' },
      { id: 'ventilateurs', label: 'Ventilateurs' },
      { id: 'gaines', label: 'Gaines & conduits' },
      { id: 'deshumidificateurs', label: 'Déshumidificateurs' },
    ]
  },
  {
    id: 'facade',
    slug: 'rayon-facade-enduit',
    label: 'Façade & Bardage',
    icon: Building2,
    emoji: '🏢',
    color: '#F97316',
    subcategories: [
      { id: 'bardage-bois', label: 'Bardage bois' },
      { id: 'bardage-composite', label: 'Bardage composite' },
      { id: 'enduits-facade', label: 'Enduits de façade' },
      { id: 'ite', label: 'ITE (Isolation par l\'extérieur)' },
      { id: 'pierre-parement', label: 'Pierre de parement' },
    ]
  },
  {
    id: 'solaire',
    slug: 'rayon-energie-solaire',
    label: 'Solaire & Énergies',
    icon: Zap,
    emoji: '☀️',
    color: '#F97316',
    subcategories: [
      { id: 'panneaux-solaires', label: 'Panneaux solaires' },
      { id: 'onduleurs', label: 'Onduleurs' },
      { id: 'batteries', label: 'Batteries de stockage' },
      { id: 'kits-solaires', label: 'Kits solaires' },
      { id: 'chauffe-eau-solaire', label: 'Chauffe-eau solaires' },
    ]
  },
  {
    id: 'outillage',
    slug: 'rayon-outillage-equipement',
    label: 'Outillage & Équipement',
    icon: Wrench,
    emoji: '🔧',
    color: '#1E3A5F',
    subcategories: [
      { id: 'perceuses', label: 'Perceuses & visseuses' },
      { id: 'scies', label: 'Scies' },
      { id: 'meuleuses', label: 'Meuleuses' },
      { id: 'compresseurs', label: 'Compresseurs' },
      { id: 'echafaudages', label: 'Échafaudages & échelles' },
      { id: 'epi', label: 'EPI (Équipements de protection)' },
      { id: 'outillage-main', label: 'Outillage à main' },
    ]
  },
];

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// HELPERS
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

// Obtenir une catégorie par ID
export const getCategoryById = (id) => {
  return CATEGORIES_BTP.find(cat => cat.id === id || cat.slug === id);
};

// Obtenir les sous-catégories d'une catégorie
export const getSubcategories = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category?.subcategories || [];
};

// Obtenir l'icône Lucide d'une catégorie
export const getCategoryIcon = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category?.icon || Package;
};

// Obtenir l'emoji d'une catégorie
export const getCategoryEmoji = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category?.emoji || '📦';
};

// Obtenir la couleur d'une catégorie (charte Abracadabâti)
export const getCategoryColor = (categoryId) => {
  const category = getCategoryById(categoryId);
  return category?.color || '#1E3A5F';
};

// Format pour les selects (options)
export const CATEGORIES_OPTIONS = CATEGORIES_BTP.map(cat => ({
  value: cat.id,
  label: `${cat.emoji} ${cat.label}`,
}));

// Export default
export default CATEGORIES_BTP;
